var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStar1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.10352 2.18896C7.47047 1.44624 8.52959 1.44618 8.89648 2.18896L10.1904 4.81104C10.3361 5.10608 10.6178 5.31148 10.9434 5.35889L13.8379 5.77881C14.6578 5.89825 14.9851 6.90642 14.3916 7.48486L12.2979 9.52588C12.0623 9.75559 11.9542 10.0863 12.0098 10.4106L12.5049 13.2925C12.645 14.1093 11.7873 14.7325 11.0537 14.3472L8.46484 12.9858C8.17361 12.8329 7.82537 12.8328 7.53418 12.9858L4.94629 14.3472C4.21268 14.7327 3.35501 14.1093 3.49512 13.2925L3.98926 10.4106C4.04488 10.0864 3.93766 9.75561 3.70215 9.52588L1.6084 7.48486C1.0149 6.90637 1.342 5.89811 2.16211 5.77881L5.05566 5.35889C5.38137 5.31156 5.66293 5.10617 5.80859 4.81104L7.10352 2.18896ZM10.9619 6.55518C10.7299 6.34254 10.3699 6.35836 10.1572 6.59033L7.70801 9.26025L6.3252 7.98389C6.09389 7.77039 5.73306 7.78485 5.51953 8.01611C5.30635 8.24737 5.32075 8.60734 5.55176 8.8208L7.35547 10.4858C7.46676 10.5884 7.61541 10.6435 7.7666 10.6372C7.91752 10.6307 8.05994 10.5639 8.16211 10.4526L10.9971 7.35986C11.2095 7.12794 11.1935 6.7679 10.9619 6.55518Z",
    fill: "#002A69"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar1);
export default __webpack_public_path__ + "static/media/Star1.83c368f53f4af8accdc79d24557ab67a.svg";
export { ForwardRef as ReactComponent };